import React, { useEffect, useState } from 'react';
import { CustomerPermission, InitContextProps, useAuthContext } from 'services/context/authentication.context';
import ConsumptionCard from './ConsumptionCard';
import { IncreaseGeneralCreditModal } from './modal/IncreaseGeneralCreditModal';
import {Button} from 'react-bootstrap';
import { CustomerApplicationType } from 'models/customer-application';

export default function CardLimit() {

    const { state, hasPermission }: InitContextProps = useAuthContext();

    const [canRequestIdCredit, setCanRequestIdCredit] = useState(false);

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (state.user !== null && state.customer !== null) {
            setCanRequestIdCredit(state.customer.isPerson && state.user.canRequestIdCredit);
        }
    }, [state.user, state.customer]);

    let isPrepaid = false;
    const creditUsed = state.customer.creditUsed;
    if (creditUsed < 0) isPrepaid = true;
    const customerBalanceLimit = state.customer.customerBalanceLimit;
    const creditRemaining = customerBalanceLimit - creditUsed;

    const hasCreditAgreement = !!state.customer?.hasCreditAgreement;
    const isIncreaseCreditBlocked = state.customer
        ?.blockingApplications?.[CustomerApplicationType.INCREASE_CREDIT_APPLICATION] != null;

    if (canRequestIdCredit || !customerBalanceLimit) return null;

    return (
        <div className="mb-4">
            <ConsumptionCard 
                title={isPrepaid ? 'Ettemaksu jääk' : 'Krediidilimiidi jääk'}
                highlightStyle='primary'
                highlightedText={(creditRemaining?.toFixed(2) ?? 0) + '€'}
                showDetails={true}
                detailsLabel='Sinu limiit:'
                detailsComponent={customerBalanceLimit + '€'}
                type='narrow'
            />
            {
                hasPermission(CustomerPermission.WEB_ADMIN) && hasCreditAgreement && !isIncreaseCreditBlocked && (
                    <Button
                        variant="primary"
                        className="mt-2"
                        onClick={() => setShowModal(true)}
                        type="button"
                    >
                        Suurenda krediiti
                    </Button>
                )
            }
            {
                showModal && (
                    <IncreaseGeneralCreditModal
                        handleModalHide={() => setShowModal(false)}
                    />
                )
            }
        </div>
    );
}